import { Component, Input, OnInit } from "@angular/core";

interface FacebookEmbedInterface {
  embed: string;
}

interface FacebookInterface {
  items: FacebookEmbedInterface[];
  template: string;
}

@Component({
  selector: "app-facebook",
  templateUrl: "./facebook.component.html",
  styleUrls: ["./facebook.component.scss"],
})
export class FacebookComponent implements OnInit {
  columnCount: number;
  items: FacebookEmbedInterface[];

  @Input() node: FacebookInterface;

  ngOnInit() {
    if (this.node?.template)
      this.columnCount = 12 / parseInt(this.node.template.replace("grid-", ""));

    this.items = this.node.items.map((item) => {
      return {
        embed: item.embed.replace("&width=500", "&width=auto"),
      };
    });
  }
}
